var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0l15 6v2h-2c0 0.547-0.484 1-1.078 1h-23.844c-0.594 0-1.078-0.453-1.078-1h-2v-2zM4 10h4v12h2v-12h4v12h2v-12h4v12h2v-12h4v12h0.922c0.594 0 1.078 0.453 1.078 1v1h-26v-1c0-0.547 0.484-1 1.078-1h0.922v-12zM28.922 25c0.594 0 1.078 0.453 1.078 1v2h-30v-2c0-0.547 0.484-1 1.078-1h27.844z",
    fill: "#727293"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankGrey);
export default __webpack_public_path__ + "static/media/BankGrey.7b10f3547683f27a1d884044362ec82d.svg";
export { ForwardRef as ReactComponent };